import React from "react";
import {makeStyles} from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import Typography from "@material-ui/core/Typography";
import Avatar from "@material-ui/core/Avatar";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import * as yup from 'yup';
import {useFormik} from 'formik';
import {SERVER_URL} from "../../utils";

const useStyles = makeStyles((theme) => ({
    paper: {
        marginTop: theme.spacing(8),
        display: "flex",
        flexDirection: "column",
        alignItems: "center"
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main
    },
    form: {
        width: "100%", // Fix IE 11 issue.
        marginTop: theme.spacing(3)
    },
    submit: {
        margin: theme.spacing(3, 0, 2)
    }
}));

const passwordRegExp = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/

const formValidationSchema = yup.object({
    confirmPassword: yup
        .string()
        .oneOf([yup.ref('password'), null], 'Le password non sono uguali')
        .required('Ripeti password'),
    password: yup
        .string()
        .matches(passwordRegExp, "La password deve contenere almeno un carattere Maiscolo, un numero e un carattere speciale")
        .required('Conferma la password')
        .min(6, 'La password deve essere lunga almeno 6 caratteri'),
});

const ForgotPassword = props => {
    
    console.log(props.match.params.id)

    const formik = useFormik({
        initialValues: {
            password: '',
            confirmPassword: '',

        },

        validationSchema: formValidationSchema,
        onSubmit: async (values) => {
            await handleChange();
        },

    });

    const handleChange = async (event) => {
        const data = {
            password: formik.values.password,
            confirmPassword: formik.values.confirmPassword,

        }

        // (BERA): Invio Form QUI
        await fetch(SERVER_URL + "api/v1/auth/service/forgot-password", {
            method: "POST",
            headers: new Headers({'Content-Type': 'application/json'}),
            body: JSON.stringify({
                id: props.match.params.id,
                newPassword: data.confirmPassword
            }),
        })
    }

    const classes = useStyles();

    return (
        <form onSubmit={formik.handleSubmit}>
            <Container component="main" maxWidth="xs">
                <CssBaseline />
                <Container className={classes.paper}>
                    <Avatar className={classes.avatar}>
                        <LockOutlinedIcon />
                    </Avatar>
                    <Typography component="h1" variant="h5">
                        Reset password
                    </Typography>
                    <Container className={classes.form}>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <TextField
                                    variant="outlined"
                                    required
                                    fullWidth
                                    name="password"
                                    label="Nuova Password"
                                    type="password"
                                    id="password"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.password}
                                    error={formik.touched.password && Boolean(formik.errors.password)}
                                    helperText={formik.touched.password && formik.errors.password}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    variant="outlined"
                                    required
                                    fullWidth
                                    name="confirmPassword"
                                    label="Conferma Password"
                                    type="password"
                                    id="confirmPassword"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.confirmPassword}
                                    error={formik.touched.confirmPassword && Boolean(formik.errors.confirmPassword)}
                                    helperText={formik.touched.confirmPassword && formik.errors.confirmPassword}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                />
                            </Grid>
                        </Grid>
                        <Button
                            type="submit"
                            fullWidth
                            variant="contained"
                            color="primary"
                            className={classes.submit}
                        >
                            Cambia Password
                        </Button>
                    </Container>
                </Container>
            </Container>
        </form>
    );
}
export default ForgotPassword;